export default __webpack_public_path__ + "static/7-33b4627147a0c29ae3ed4e87737032ab.jpg";